define('views/blocks/CartAdvantagesView',['jquery','underscore','backbone','app','SubView',
        'TagCommander',
        'template!blocks/cart/advantages',
        'template!blocks/ui/check-switch'
       ],
    function ($,_,Backbone,app,SubView,
              TagCommander,
              advantagesTemplate
              ) {

        //
        // représente le bloc avantages utilisable dans le panier
        //
        var index = 0, max, displayAsModal;

        return Backbone.View.extend(SubView).extend({

            events: {
                'click .btn-close, .cart-advantages__btn-submit':'close',
                'change :checkbox':'selectAdvantage',
                'click .cart-advantages__nav button':'clickPrevNext',
                'click .advantage-add-product':'clickAddProduct',
                'click .cart-advantages__item':'clickItem',
            },

            className: 'cart-advantages',
            displayAsModal: true,

            initialize: function (options) {
                var view = this,
                    cart = app.getCart(),
                    customer = app.getCustomer();
                displayAsModal = !!options.displayAsModal;
                view.listenTo(cart,'change:discounts',view.changeDiscounts);
                view.listenTo(customer,'change:usableAdvantagesOnCart login logout',view.render);
                view.render();
                index = 0;
            },
            render: function () {

                var view = this,
                    cart = app.getCart(),
                    advantages = cart.getUsableAdvantages(false,true),
                    count = advantages.size(),
                    rawHtml = advantagesTemplate({
                        displayAsModal: displayAsModal,
                        count:count,
                        advantages:advantages
                    });
                max = count-2;

                if(displayAsModal){
                    view.$el.html(rawHtml);
                }else{
                    view.$('.cart-advantages__list').html(rawHtml);
                }
                view.onChangeAdvantages();
                view.delegateEvents();
            },
            clickPrevNext:function(e){
                this.navigateOffset($(e.currentTarget).is(':first-child')?-1:1);
            },
            navigateOffset:function(offset){
                var view = this,
                    outerWidth = view.$('.cart-advantages__item').outerWidth(true);
                index += offset;
                index = index<0 ? max : index>max ? 0: index;
                view.$('.cart-advantages__list__wrapper').stop(true, false).animate({
                    scrollLeft: index * outerWidth
                })

            },
            onChangeAdvantages:function(){
                var view = this,
                    cart = app.getCart(),
                    prefixSelector = '.cart-advantages',
                    advantagesCount = cart.getUsableAdvantages(false,true).size(),
                    advantagesAttr = {
                        "data-advantages-count":advantagesCount,
                        "data-advantages-enable":(!!advantagesCount || !app.getCustomer().isLogged())?1:0
                    };
                if(view.$el.is(prefixSelector)){
                    view.$el.attr(advantagesAttr);
                }else{
                    view.$(prefixSelector).attr(advantagesAttr);
                }
                view.$(prefixSelector+'__list').attr(advantagesAttr);
                view.$('.cart__badge').text(advantagesCount);
            },
            clickItem:function(e){
                var target = e.target, labelSelector = '.advantage-label';
                if(!$(target).parents(labelSelector).get(0) && !$(target).is(labelSelector)){
                    $(e.currentTarget).find('.advantage-label').click();
                }
            },
            selectAdvantage:function(e){
                var view = this,
                    input = e.currentTarget,
                    label = $(input).parents('label'),
                    item = $(input).parents('.cart-advantages__item'),
                    circleLoader = label.find('.circle-loader'),
                        cart = app.getCart(),
                    id_advantage = input.name.replace('advantage-choice-',''),
                    checked = input.checked,
                    advantage = cart.getUsableAdvantages(false,true).get(id_advantage);
                input.disabled = true;
                circleLoader.addClass('playing');

                TagCommander.eventGA(input,"Panier","Utiliser un avantage",advantage.getName());

                function complete(){
                    view.stopListening(advantage,'used',complete);
                    view.stopListening(advantage,'canceled',complete);
                    var checked = input.checked = advantage.isUsedInCart();
                    item.toggleClass('cart-advantages__item--used',checked);
                    input.disabled = false;
                    circleLoader.removeClass('playing');
                }

                if(checked){
                    view.listenToOnce(advantage,'used',complete);
                    view.listenToOnce(advantage,'canceled',complete);
                    advantage.use();
                }else{
                    view.listenToOnce(advantage,'canceled',complete);
                    advantage.cancel();
                }
                //this.$('.submit').attr('disabled',false);
            },
            clickAddProduct:function(e){
                var view = this,
                    button = e.currentTarget,
                    cart = app.getCart(),
                    id_advantage = button.name.replace('advantage-choice-',''),
                    advantage = cart.getUsableAdvantages(false,true).get(id_advantage);
                ;
                function toggleLoading(state){
                    $(button).attr('disabled',state).toggleClass('loading',state);
                }

                function complete(){
                    toggleLoading(false);
                }
                toggleLoading(true);
                view.listenToOnce(advantage,'used',complete);
                advantage.use();
            },
            changeDiscounts:function(cart,discounts){
                var view = this;
                view.$('.advantage-label').each(function(){
                    var voucher = $(this).data('voucher'), checkbox = $(':checkbox',this);
                    if(voucher && checkbox.get(0)){
                        var discount = _(discounts).findWhere({name:voucher.toUpperCase()})
                        checkbox.prop('checked',!!discount);
                        $(checkbox).parents('.cart-advantages__item').toggleClass('cart-advantages__item--used',!!discount);
                    }
                })

            },
            close: function ()
            {
                this.trigger('close', this);
            }

        });
    });
